<ng-container *ngFor="let item of contactGroupList; let i=index">
    <div id="{{'contact-group-container' + i}}" (click)="handleClicked($event, item)" [ngClass]="{ 'active' : selectedSection == 'contactGroup' && item.GroupTypeName === selectedSectionItem }" class="list-item">
        <span>{{ item.GroupTypeName }}</span>
        <div class="right-icon" *ngIf="toggleStatusCompletedIcon(item.GroupData)">
            <svg class="icon-16 green-icon-fill">
                <use href="../App_Themes/CXone/icons/status-completed.svg#status-completed"></use>
            </svg>
        </div>
    </div>
</ng-container>